import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { methodSteps } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function MethodSection() {
  return <section className="bg-mp-dark py-16 md:py-24" data-id="element-197" data-mp="3uzudzjsz7bgf">
      <Container data-id="element-198" data-mp="vjfktvjilufn">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-199" data-mp="vhut0dol4plh">
          <SectionTag tone="lime" data-id="element-200" data-mp="qjt6tjvv4a5s">El método "Ficha en Mano"</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-201" data-mp="qkl2eupgm7w2">
            Preparar tu clase puede ser así de sencillo.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-202" data-mp="hr968dw0fvib">
          {methodSteps.map((step, i) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i * 0.06
        }} className="rounded-2xl border border-mp-border bg-mp-card p-6" data-id="element-203" data-mp="1ebi83pqnw8yv" data-mpi={i}>
              <span className="flex h-10 w-10 items-center justify-center rounded-full border border-mp-lime/40 font-heading text-sm text-mp-lime" data-id="element-204" data-mp="1lbwb8osll9ha">
                {step.number}
              </span>
              <p className="mt-4 font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-205" data-mp="1ca6b8uknh27w">{step.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-206" data-mp="1hc5g68w1g76y">{step.copy}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-207" data-mp="17cejc0k09g3p">
          <CTAButton href="#oferta" showArrow fullWidthMobile={false} data-id="element-208" data-mp="17dfvy9go6anj">
            Quiero dejar de improvisar
          </CTAButton>
        </div>
      </Container>
    </section>;
}